module.exports = __webpack_public_path__ + "img/19.1fc011d2.svg";